module.exports = __webpack_public_path__ + "static/img/gzhj.d2ebbf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gzhj.png
// module id = PxQv
// module chunks = 0